<template>
  <div :class="['util-richtext', { 'is-dark': isDark }]">
    <SharedBaseRichtext
      v-if="hasText"
      v-editable="blok"
      :text="blok.text"
      :isDark="isDark"
      :isProseEnabled="isProseEnabled"
      :isProseParagraphsEnabled="isProseParagraphsEnabled"
      :preventInlineIcons="preventInlineIcons"
      :textSize="textSize"
      :class="[{ 'is-dark': isDark }]" />
    <div v-if="actions?.length" class="actions">
      <template v-for="(action, index) in actions" :key="index">
        <UtilLinkItemIcon
          v-if="action.component === 'util_link-overlay-item'"
          :blok="action"
          :isDark="isDark"
          :hideInternalIcon="props.hideInternalIcons" />
        <UtilLinkItemSubtext v-if="action.component === 'util_link-item-subtext'" :blok="action" :isDark="isDark" />
        <UtilButton v-if="action.component === 'util_button'" :blok="action" :isBackgroundDark="isDark" />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { SharedBaseRichtext } from '@seb-platform/shared/components/base';
import UtilButton from '~/components/storyblok/utils/UtilButton/UtilButton.vue';
import UtilLinkItemIcon from '~/components/storyblok/utils/UtilLinkItemIcon/UtilLinkItemIcon.vue';
import UtilLinkItemSubtext from '~/components/storyblok/utils/UtilLinkItemSubtext/UtilLinkItemSubtext.vue';
import type { UtilRichtextLightStoryblok, UtilRichtextStoryblok } from '~/types/storyblok-generated';

const props = withDefaults(
  defineProps<{
    blok: UtilRichtextStoryblok | UtilRichtextLightStoryblok;
    isDark?: boolean;
    isProseEnabled?: boolean;
    isProseParagraphsEnabled?: boolean;
    textSize?: 'large' | 'medium';
    // Prevents hydrating links with inline icons (used for cm media...)
    preventInlineIcons?: boolean;
    //hides icons for internal links
    hideInternalIcons?: boolean;
  }>(),
  {
    isProseEnabled: true,
    isProseParagraphsEnabled: true,
    textSize: 'large',
  }
);

// TODO ensure this works with other variants / are other variants needed?
const actions = computed(() => (props.blok.component === 'util_richtext' ? props.blok.actions : []));

const hasText = computed(() => JSON.stringify(props.blok.text?.content).includes('text'));
</script>

<style src="./UtilRichtext.scss" lang="scss" scoped />
